import React from 'react';
import PropTypes from 'prop-types';
import Dialog from "@mui/material/Dialog";
import {DialogContent, DialogTitle, Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {greyishBlue500} from "../../../../assets/jss/main";

TicketModal.propTypes = {

};

function TicketModal({open}) {
    return (
        <Dialog open={open}>
            <DialogTitle>
                <Grid container>
                    <span style={{fontWeight: 'bold'}}><FormattedMessage id="retailer.picking.list.ticketModal.title" /></span>
                    <span style={{color: greyishBlue500, fontWeight: 400, fontSize: '16px'}}><FormattedMessage id="retailer.picking.list.ticketModal.subtitle" /></span>
                </Grid>

            </DialogTitle>
            <DialogContent>
                <p>Scan the article you want to prepare for picking.</p>
            </DialogContent>
        </Dialog>
    );
}

export default TicketModal;